import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const FooterWrapper = styled.footer`
  background-color: var(--dark);
  color: var(--light);
  padding: 5rem 0 0;
`;

const FooterTop = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
`;

const FooterColumn = styled.div`
  h4 {
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
    color: var(--white);
    position: relative;
    padding-bottom: 0.75rem;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 2px;
      background-color: var(--secondary);
    }
  }
`;

const FooterLinks = styled.ul`
  li {
    margin-bottom: 0.75rem;
  }
  
  a {
    color: var(--light);
    transition: var(--transition);
    
    &:hover {
      color: var(--secondary);
      padding-left: 5px;
    }
  }
`;

const ContactInfo = styled.ul`
  li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 1rem;
    
    svg {
      margin-right: 1rem;
      margin-top: 5px;
      color: var(--secondary);
    }
    
    a {
      color: var(--light);
      transition: var(--transition);
      text-decoration: none;
      
      &:hover {
        color: var(--secondary);
      }
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    color: var(--white);
    transition: var(--transition);
    
    &:hover {
      background-color: var(--secondary);
      transform: translateY(-3px);
    }
  }
`;

const FooterBottom = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
  padding: 1.5rem 0;
  text-align: center;
  margin-top: 2rem;
  
  p {
    margin-bottom: 0;
    font-size: 0.875rem;
    color: var(--gray);
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <div className="container">
        <FooterTop>
          <FooterColumn>
            <h4>About Shoffner Homes</h4>
            <p>
              Shoffner Homes, LLC is a premier residential home building construction company
              based in the NC Triad area, committed to quality craftsmanship and customer satisfaction.
            </p>
            <SocialLinks>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
            </SocialLinks>
          </FooterColumn>
          
          <FooterColumn>
            <h4>Quick Links</h4>
            <FooterLinks>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/homes-for-sale">Homes For Sale</Link></li>
              <li><Link to="/rental-properties">Rental Properties</Link></li>
              <li><Link to="/land-development">Land Development</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </FooterLinks>
          </FooterColumn>
          
          <FooterColumn>
            <h4>Our Services</h4>
            <FooterLinks>
              <li><Link to="/homes-for-sale">New Construction Homes</Link></li>
              <li><Link to="/contact">Custom Home Building</Link></li>
              <li><Link to="/land-development">Land Development</Link></li>
              <li><Link to="/rental-properties">Property Rentals</Link></li>
            </FooterLinks>
          </FooterColumn>
          
          <FooterColumn>
            <h4>Contact Information</h4>
            <ContactInfo>
              <li>
                <FaMapMarkerAlt />
                <a href="https://www.google.com/maps/place/Greensboro,+NC" target="_blank" rel="noopener noreferrer">
                  Serving the NC Triad
                </a>
              </li>
              <li>
                <FaPhone />
                <a href="tel:3365166716">(336) 516-6716</a>
              </li>
              <li>
                <FaEnvelope />
                <a href="mailto:carl@shoffnerhomes.com?subject=Shoffner%20Homes%20Website%20Inquiry">
                  carl@shoffnerhomes.com
                </a>
              </li>
            </ContactInfo>
          </FooterColumn>
        </FooterTop>
      </div>
      
      <FooterBottom>
        <div className="container">
          <p>
            &copy; {new Date().getFullYear()} Shoffner Homes, LLC. All Rights Reserved. 
            Site designed and built by <span style={{ color: 'var(--secondary)' }}>Carl Shoffner</span>
          </p>
        </div>
      </FooterBottom>
    </FooterWrapper>
  );
};

export default Footer;